import React, { useState, useEffect } from 'react';
import { B } from '../constants';
import { promos as promosAPI } from '../api';

const PLATFORM_LABELS = {
  insta_reel: 'Instagram Reels',
  fb_reel: 'Facebook Reels',
  twitter: 'Twitter/X',
  yt_shorts: 'YouTube Shorts',
};

export default function DurationAnalyzer({ duration, onSuggestion }) {
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    promosAPI.analyzeDuration(duration)
      .then(result => { if (mounted) setAnalysis(result); })
      .catch(() => { if (mounted) setAnalysis(null); })
      .finally(() => { if (mounted) setLoading(false); });
  }, [duration]);

  if (loading) {
    return (
      <div style={{ padding: 12, borderRadius: 10, background: B.sand, marginBottom: 16, textAlign: 'center', fontSize: 13, color: B.muted }}>
        Analyzing platform compatibility...
      </div>
    );
  }

  if (!analysis) return null;

  const allFit = analysis.recommendations.every(r => r.fits);

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: B.muted, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
        Platform Compatibility — {duration}s video
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {analysis.recommendations.map(rec => (
          <div key={rec.platform}
            style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 10, background: rec.fits ? 'rgba(26,107,74,0.08)' : rec.tooLong ? 'rgba(220,53,69,0.08)' : 'rgba(245,166,35,0.08)' }}>
            <span style={{ fontSize: 18 }}>
              {rec.fits ? '✅' : rec.tooLong ? '❌' : '⚠️'}
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: 13 }}>{PLATFORM_LABELS[rec.platform] || rec.label}</div>
              <div style={{ fontSize: 11, color: B.muted }}>
                Max {rec.maxDuration}s {rec.needsTrim && `· ${rec.excessSecs}s over limit`}
              </div>
            </div>
            {rec.needsTrim && !rec.tooLong && (
              <button onClick={() => onSuggestion?.(rec.suggestedTrimDuration)}
                style={{ padding: '5px 10px', borderRadius: 6, border: 'none', background: B.forest, color: 'white', cursor: 'pointer', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' }}>
                Trim to {rec.maxDuration}s
              </button>
            )}
            {rec.tooLong && (
              <span style={{ fontSize: 11, color: '#dc3545', fontWeight: 600, whiteSpace: 'nowrap' }}>Too long</span>
            )}
          </div>
        ))}
      </div>
      {!allFit && analysis.suggestedTrimDuration && (
        <div style={{ marginTop: 8, padding: '10px 14px', borderRadius: 10, background: 'rgba(245,166,35,0.1)', fontSize: 12, color: '#8a6d00', lineHeight: 1.5 }}>
          💡 Tip: Trimming to {analysis.suggestedTrimDuration}s will make this video compatible with all platforms except those marked ❌
        </div>
      )}
    </div>
  );
}
